import React, { useRef } from "react"
import { useDispatch, useSelector } from "react-redux"
import { setFormData } from "../../redux/formSlice"
import { colorTheme } from "../../data/SrtingConstants"
import GoogleAddress from "./GoogleAddress"

const ServiceAddress: React.FC = () => {
  const dispatch = useDispatch()
  const formData = useSelector((state: any) => state.form)
  const inputRef = useRef<HTMLInputElement | null>(null)
  const unitRef = useRef<HTMLInputElement | null>(null)

  return (
    <div className="flex justify-center w-full">
      <GoogleAddress
        googleAddressType={"shipping_address"}
        inputRef={inputRef}
        unitRef={unitRef}
      />
      <div className="bg-white m-3 self-center sm:m-10 md:m-16 flex flex-col sm:flex-row sm:items-center p-2 lg:p-1 rounded-3xl text-center w-full max-w-2xl">
        <input
          ref={inputRef}
          style={{ fontVariantLigatures: "none" }}
          type="text"
          name="address"
          className="border-none text-lg sm:text-xl font-normal font-tt placeholder:font-tt text-black bg-transparent flex-1 min-w-0 p-2 placeholder:text-[#A6A6A6] placeholder:font-medium"
          placeholder="Enter your address"
          defaultValue={formData?.shipping_address?.Line1 || ""}
        />
        <div
          className={`text-gray-300 hidden sm:block transition-colors duration-200 group-focus-within:text-[${colorTheme.MEDIUM_PURPLE}]`}
        >
          |
        </div>
        <input
          ref={unitRef}
          style={{ fontVariantLigatures: "none" }}
          type="text"
          maxLength={10} // <-- Prevents typing more than 10 characters
          autoComplete="off"
          className="border-none fonts-normal text-lg sm:text-xl font-tt placeholder:font-tt text-black bg-transparent flex-1 min-w-0 p-2 placeholder:text-[#A6A6A6] placeholder:font-normal"
          name="line2"
          id="line2_address"
          placeholder="Unit"
          defaultValue={formData?.shipping_address?.SubBuilding}
          onChange={(e) => {
            e.target.value?.length <= 10 &&
              dispatch(
                setFormData({
                  shipping_address: {
                    ...formData.shipping_address,
                    SubBuilding: e?.target?.value?.toUpperCase(),
                  },
                })
              )
          }}
        />
      </div>
    </div>
  )
}

export default ServiceAddress
